import React from 'react';
import { Box, keyframes } from '@mui/material';

const pulse = keyframes`
  0% { filter: drop-shadow(0 0 2px #60A5FA); }
  50% { filter: drop-shadow(0 0 8px #60A5FA); }
  100% { filter: drop-shadow(0 0 2px #60A5FA); }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const glow = keyframes`
  0% { filter: drop-shadow(0 0 3px #60A5FA); }
  50% { filter: drop-shadow(0 0 12px #60A5FA) brightness(1.2); }
  100% { filter: drop-shadow(0 0 3px #60A5FA); }
`;

const AnimatedLogo = ({ isOpen }) => {
  return (
    <Box
      sx={{
        width: isOpen ? 200 : 48,
        height: 48,
        m: 2,
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        position: 'relative',
        '&:hover': {
          transform: 'scale(1.02)',
          '& .outer-hexagon': {
            animation: `${rotate} 12s linear infinite`
          },
          '& .inner-circles': {
            animation: `${rotate} 8s linear infinite reverse`
          },
          '& .core': {
            animation: `${pulse} 2s ease-in-out infinite`
          },
          '& .text-part': {
            animation: `${glow} 2s ease-in-out infinite`
          }
        }
      }}
    >
      <svg
        viewBox="0 0 240 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {/* Outer Hexagon */}
        <g className="outer-hexagon">
          <path
            d="M50 10L85 30L85 70L50 90L15 70L15 30L50 10Z"
            stroke="#60A5FA"
            strokeWidth="2"
            strokeDasharray="4 4"
            fill="none"
          />
        </g>

        {/* Inner Circles Pattern */}
        <g className="inner-circles">
          <circle cx="50" cy="50" r="25" stroke="#60A5FA" strokeWidth="1.5" strokeDasharray="3 3" />
          <circle cx="50" cy="50" r="20" stroke="#60A5FA" strokeWidth="1.5" strokeDasharray="2 2" />
          <circle cx="50" cy="50" r="15" stroke="#60A5FA" strokeWidth="1.5" strokeDasharray="1 1" />
        </g>

        {/* Core Elements */}
        <g className="core">
          {/* Central Shield */}
          <path
            d="M50 35L65 45V65L50 75L35 65V45L50 35Z"
            fill="#60A5FA"
            fillOpacity="0.8"
          />
          {/* Center Point */}
          <circle cx="50" cy="50" r="8" fill="#60A5FA" />
          {/* Decorative Lines */}
          <path
            d="M50 42V58M42 50H58"
            stroke="white"
            strokeWidth="1"
          />
        </g>

        {/* Text Part */}
        {isOpen && (
          <g className="text-part">
            <text
              x="95"
              y="45"
              style={{
                fill: '#60A5FA',
                fontSize: '24px',
                fontFamily: 'Orbitron, sans-serif',
                fontWeight: 'bold'
              }}
            >
              Exploit
            </text>
            <text
              x="95"
              y="70"
              style={{
                fill: '#60A5FA',
                fontSize: '24px',
                fontFamily: 'Orbitron, sans-serif',
                fontWeight: 'bold'
              }}
            >
              Finder
            </text>
          </g>
        )}
      </svg>
    </Box>
  );
};

export default AnimatedLogo;
